import { BucketManifest, useCacheContext } from 'Workspace/Cache';

export function useEncryptedStorage() {
	return useCacheContext().cacheFactory.createEncryptedCacheBucket(
		BucketManifest.actions
	);
}
